import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../redux/instance/api";

export const getOrganizationAttributes = createAsyncThunk(
  "member/getOrganizationAttributes",
  async (_, { rejectWithValue }) => {
    try {
      const organisationId = localStorage.getItem('organisationId');
      const response = await api.get(`/organisation-attribute/attributesByOrganization/${organisationId}`);

      const status = "success";
      const data = {
        status: status,
        message: response.data,
      };
      return data;
    } catch (error) {
      const status = "error";
      const data = {
        status: status,
        message:
          error.response?.data || "Something went wrong, please try again.",
      };
      return rejectWithValue(data);
    }
  }
);

const organizationAttributesSlice = createSlice({
  name: "organizationAttributes",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getOrganizationAttributes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getOrganizationAttributes.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getOrganizationAttributes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || action.error.message;
      });
  },
});

export default organizationAttributesSlice.reducer;
